import classNames from 'classnames';
import React, {useState} from 'react';

import FlowchartActionFunctionButton from 'processes/graph-builder/flowchart-viz/FlowchartActionFunctionButton';
import {
  FlowchartActionFunction,
  FlowchartActionItem,
  FlowchartBase,
} from 'processes/graph-builder/flowchart-viz/FlowchartVizConstants';

interface FlowchartActionFunctionButtonToolbarProps<
  TItem extends FlowchartActionItem,
  TFlowchart extends FlowchartBase,
> {
  actionFunctions: Array<FlowchartActionFunction<TItem, FlowchartBase>>;
  item: TItem;
  className?: string;
}

export function FlowchartActionFunctionButtonToolbar<
  TItem extends FlowchartActionItem,
  TFlowchart extends FlowchartBase,
>(props: FlowchartActionFunctionButtonToolbarProps<TItem, TFlowchart>): JSX.Element {
  const [isVisible, setIsVisible] = useState(true);
  return (
    <>
      {isVisible && (
        <div className={classNames('buttonToolbar', props.className)}>
          {props.actionFunctions.map((actionFunction, idx) => (
            <div key={idx}>
              <FlowchartActionFunctionButton
                actionFunction={actionFunction}
                item={props.item}
                setIsActionFunctionToolbarVisible={setIsVisible}
              />
            </div>
          ))}
        </div>
      )}
    </>
  );
}
